import React, { useContext } from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { AccessManagement2NModalContext } from '../../../AccessManagement2NModalContext';
import styles from './styles.module.scss';

export const Group = ({ group }) => {

  const { selectedGroup, setSelectedGroup } = useContext(AccessManagement2NModalContext);

  const onGroupClick = () => {
    setSelectedGroup(group);
  };

  return (
    <div
      className={styles.groupCard}
      onClick={onGroupClick}
    >
      <div className={styles.details}>
        {/*<div className={styles.icon}>*/}
        {/*  {group.icon}*/}
        {/*</div>*/}
        <Text
          size={14}
          uppercase
        >
          {group.Name}
        </Text>
      </div>

      <ShouldRender condition={selectedGroup && selectedGroup.Id === group.Id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
